
import { css } from 'lit';
export default css`
.pc-search-teaser{
  margin-top:-2px;
}

.pc-search-teaser--desktop-wrapper{
  display:flex;
  padding:var(--spacing-8);
  column-gap:var(--spacing-8);
  border-top:solid 2px var(--purple-medium-neutral);
  border-bottom:solid 2px var(--purple-medium-neutral);
}

.pc-search-teaser--desktop-type{
  width:100%;
  max-width:15%;
  display:flex;
  flex-direction:column;
  font-size:var(--fs-sm);
  row-gap:var(--spacing-2);
}

.pc-search-teaser--desktop-type slot[name="type"]{
    color:var(--purple-indigo);
    line-height:100%;
  }

.pc-search-teaser--desktop-type slot[name="subtype"]{
    line-height:100%;
    color:var(--neutral-medium-gray);
  }

.pc-search-teaser--desktop-main{
  display:flex;
  flex-direction:column;
  max-width:60%;
  width:100%;
  row-gap:var(--spacing-2);
}

.pc-search-teaser--desktop-image{
  display:flex;
  width:100%;
  max-width:10%;
  min-width:90px;
  margin-left:auto;
}

.pc-search-teaser--mobile-wrapper{
  display:flex;
  flex-direction:column;
  padding:var(--spacing-5) 0;
  row-gap:var(--spacing-4);
  border-top:solid 2px var(--purple-medium-neutral);
  border-bottom:solid 2px var(--purple-medium-neutral);
}

.pc-search-teaser--mobile-type{
  width:100%;
  display:flex;
  flex-direction:row;
  column-gap:var(--spacing-3);
  font-size:var(--fs-sm);
  align-items:center;
}

.pc-search-teaser--mobile-type slot[name="type"]{
    color:var(--purple-indigo);
  }

.pc-search-teaser--mobile-type slot[name="subtype"]{
    color:var(--neutral-medium-gray);
  }

.pc-search-teaser--mobile-main{
  display:flex;
  flex-direction:column;
  width:100%;
  row-gap:var(--spacing-2);
}

.pc-search-teaser--mobile-image{
  display:flex;
  width:100%;
  max-width:20%;
  min-width:65px;
  margin-right:auto;
}`;